var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12 3.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm3.898 12.26a.53.53 0 01-.729.175c-1.995-1.219-4.508-1.495-7.467-.819a.53.53 0 01-.235-1.033c3.237-.74 6.015-.422 8.255.948a.53.53 0 01.176.728zm1.04-2.315a.662.662 0 01-.911.219c-2.285-1.405-5.768-1.812-8.47-.992a.664.664 0 01-.385-1.268c3.087-.936 6.924-.483 9.548 1.13.312.192.41.6.218.91zm.09-2.41c-2.74-1.628-7.26-1.777-9.875-.983A.795.795 0 116.69 8.53c3.003-.911 7.994-.735 11.148 1.137a.794.794 0 11-.81 1.368h-.001z"
  }));
}
export default SvgIconSpotify;